import { AxiosResponse } from 'axios'
import { axiosInstance } from '~/src/config/config_axios'
import { ICurrencyBody, ISettingCurrenciesResponse } from './models/SettingCurrency'

export class SettingCurrencyRepository {
  async getCurrencies(): Promise<AxiosResponse<ISettingCurrenciesResponse['data']>> {
    return axiosInstance.get('currencies')
  }

  async patchCurrencies(body: ICurrencyBody[]): Promise<AxiosResponse<any>> {
    return await axiosInstance.patch('currencies', body)
  }
}
